import Vue from "vue"
import Vuetify from "vuetify"
import colors from "vuetify/lib/util/colors"
import es from "@/assets/locale/es"
import minifyTheme from "minify-css-string"
import "vuetify/dist/vuetify.min.css"
import "@/assets/css/style.css"

Vue.use(Vuetify)

const opts = {
  theme: {
    dark: false
    , themes: {
      light: {
        primary: colors.blue.darken3 // #E53935
        , secondary: colors.blue.lighten2 // #FFCDD2
        , accent: colors.blue.accent3 // #3F51B5
      }
      , dark: {
        primary: colors.blue.darken3 // #E53935
        , secondary: colors.blue.lighten2 // #FFCDD2
        , accent: colors.blue.accent3 // #3F51B5
      }
    }
    , options: {
      themeCache: {
        get: key => localStorage.getItem(key)
        , set: (key, value) => localStorage.setItem(key, value)
      }
      , minifyTheme
      , customProperties: true
    }
  }
  , lang: {
    locales: { es }
    , current: "es"
  }
}

export default new Vuetify(opts)


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js